<div *ngIf="canAccess" class="p-2 bg-gray-opacity rounded-2xl flex flex-col gap-6 md:gap-8 md:p-6">
  <app-spinner spinnerId="btb-download"></app-spinner>
  
  <div *ngIf="(spinnerService.getSpinnerState('btb-dashboard') | async)" class="flex justify-center items-center min-h-[200px]">
    <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
  </div>
  
  <div *ngIf="!(spinnerService.getSpinnerState('btb-dashboard') | async)">
    <div class="relative mb-16">
      <div class="text-center">
        <h1 class="text-3xl font-bold text-black">{{ 'BTB.DASHBOARD.TITLE' | translate }}</h1>
      </div>
      <div class="absolute top-0 right-0">
        <app-button routerLink="/btb/profile" class="text-sm px-3 py-1">
          {{ 'BTB.DASHBOARD.GO_TO_PROFILE' | translate }}
        </app-button>
      </div>
    </div>

    <app-btb-partner-info 
      [partnerInfo]="partnerInfo"
      [showEmail]="false"
      [showCopyButton]="true"
      (copyRegistrationLink)="copyRegistrationLink()">
    </app-btb-partner-info>

    <div class="mt-8"></div>

    <app-btb-tabs 
      [tabs]="tabs"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($event)">

      <div [hidden]="activeTab !== 'transactions'">
        <app-btb-transactions-list
          [transactions]="userTransactions"
          [filterFields]="filterTransactionsFields"
          [filteredCount]="filteredCounts.userTransactions"
          (filteredCountChange)="onTransactionsFilteredCountChange($event)"
          (buscarPorFechasEvent)="onBuscarPorFechas($event)">
        </app-btb-transactions-list>
      </div>
      
      <div [hidden]="activeTab !== 'invoices'">
        <app-btb-invoices-list
          [allInvoices]="allInvoices"
          [filterFields]="filterFields"
          [showAddButton]="true"
          [isBackoffice]="false"
          [pendingTotal]="pendingTotal"
          [totalBilling]="totalBilling"
          (invoiceAction)="onInvoiceAction($event)"
          (addInvoice)="addInvoice()"
          (filteredCountChange)="onFilteredCountChange($event)">
        </app-btb-invoices-list>
      </div>
      
      <div [hidden]="activeTab !== 'commission'">
        <app-btb-commission-list [conditions]="condicionesComision"></app-btb-commission-list>
      </div>
    </app-btb-tabs>
  </div>
</div>
